import Bronze from "assets/svgs/Bronze"
import Gold from "assets/svgs/Gold"
import Silver from "assets/svgs/Silver"

export default function Badge({ type, className }: any) {
  if (type === "bronze") return <Bronze className={className} />
  else if (type === "silver") return <Silver className={className} />
  return <Gold className={className} />
}
